<template>
  <div
    :class="{
      content: true,
      page: page.total > queryParams.Limit,
    }"
    ref="content"
  >
    <div class="main-content">
      <div class="search-box" ref="search">
        <a-form>
          <a-row>
            <a-col :xxl="4" :xs="6">
              <s-input
                title="标题"
                :labelCol="6"
                :valueCol="16"
                v-model:value="queryParams.Title"
              />
            </a-col>
            <a-col :xxl="4" :xs="6">
              <s-select
                title="区域"
                v-model:value="queryParams.DepartmentId"
                :options="departments"
              />
            </a-col>
            <a-col :xxl="4" :xs="6">
              <s-select
                title="分类"
                v-model:value="queryParams.GoodsCategoryId"
                :options="goodsCategorys"
              />
            </a-col>
            <a-col>
              <a-button type="primary" @click="getDataList(1)">查询</a-button>
              <a-button
                type="primary"
                @click="reset(() => resetFun())"
                danger
                style="margin-left: 10px"
              >
                重置
              </a-button>
              <a-button
                type="primary"
                style="margin-left: 10px"
                @click="addForm(() => $refs.eForm.open(null))"
              >
                添加
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="data-list">
        <a-table
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :loading="loading"
          :row-key="(record) => record.id"
          :scroll="{ y: height, x: width }"
        >
          <template #bodyCell="{ column, record, index }">
            <template v-if="column.key === 'index'">
              {{ (page.page - 1) * queryParams.Limit + index + 1 }}
            </template>

            <template v-if="column.key === 'title'">
              <div class="goods">
                <div class="pic">
                  <img :src="record.pic" alt="" />
                </div>
                <div class="info">
                  <div class="title">{{ record.title }}</div>
                  <div class="price">
                    ¥{{ record.promotionPrice }} / {{ record.unit }}
                  </div>
                </div>
              </div>
            </template>

            <template v-if="column.key === 'createTime'">
              {{ $filters.formatDate(record.createTime, "YYYY-MM-DD HH:mm") }}
            </template>

            <template v-if="column.key === 'isSelling'">
              <a-switch
                v-model:checked="record.isSelling"
                checked-children="上架"
                un-checked-children="下架"
                @change="changeIsSelling(record.id, $event)"
              />
            </template>

            <template v-if="column.key === 'department'">
              <div>{{ record.department ? record.department.name : "" }}</div>
            </template>

            <template v-if="column.key === 'action'">
              <a-tooltip>
                <template #title>下单</template>
                <a @click.stop="$refs.order.open(record)">
                  <file-add-outlined />
                </a>
              </a-tooltip>
              <a-divider type="vertical" />
              <a-tooltip>
                <template #title>编辑</template>
                <a @click.stop="editForm(() => $refs.eForm.open(record))">
                  <EditOutlined />
                </a>
              </a-tooltip>
              <a-divider type="vertical" />
              <a-tooltip>
                <template #title>删除</template>
                <a @click.stop="delForm(() => delFormFun(record))"
                  ><DeleteOutlined
                /></a>
              </a-tooltip>
            </template>
          </template>
        </a-table>
      </div>
    </div>

    <div class="pagination">
      <a-pagination
        :total="page.total"
        v-model:page-size="queryParams.Limit"
        :hide-on-single-page="true"
        :show-size-changer="true"
        :page-size-options="['20', '40', '100', '200']"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
      >
        <template #itemRender="{ page, type }">
          <a v-if="type === 'prev'" class="ant-pagination-item-link">上一页</a>
          <a v-else-if="type === 'next'" class="ant-pagination-item-link">
            下一页
          </a>
          <span v-else>{{ page }}</span>
        </template>
      </a-pagination>
      <span>数据总数：{{ page.total }}</span>
    </div>

    <EForm ref="eForm" @ok="getDataList(1)" />
    <Order ref="order" @ok="$router.push({ name: 'manage-order-list' })" />
  </div>
</template>

<script>
import { defineComponent, ref, createVNode } from 'vue'
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  FileAddOutlined
} from '@ant-design/icons-vue'
import { GoodsClass } from '@/apis/goods'
import page from '@/mixins/page'

import EForm from '@/components/forms/goods/Form'
import Order from '@/components/forms/order/Form'

const api = new GoodsClass()
export default defineComponent({
  mixins: [page],
  components: {
    EditOutlined,
    DeleteOutlined,
    EForm,
    Order,
    FileAddOutlined
  },
  setup () {
    const loading = ref(false)
    const height = ref(500)
    const width = ref(500)

    const columns = [
      {
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60
      },
      {
        title: '分类',
        dataIndex: 'goodsCategoryName',
        key: 'goodsCategoryName',
        width: 120
      },
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        width: 300
      },
      {
        title: '原价',
        dataIndex: 'sellingPrice',
        key: 'sellingPrice',
        width: 120
      },
      {
        title: '售价',
        dataIndex: 'promotionPrice',
        key: 'promotionPrice',
        width: 100
      },
      {
        title: '单位',
        dataIndex: 'unit',
        key: 'unit',
        width: 100
      },
      {
        title: '状态',
        dataIndex: 'isSelling',
        key: 'isSelling',
        width: 100
      },
      {
        title: '区域',
        dataIndex: 'department',
        key: 'department',
        width: 160
      },
      {
        title: '添加时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 160
      },
      {
        title: '添加用户',
        dataIndex: 'creatorName',
        key: 'creatorName',
        width: 120
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 100,
        fixed: 'right'
      }
    ]

    const departments = ref([])
    const goodsCategorys = ref([])
    return {
      columns,
      loading,
      height,
      width,
      departments,
      goodsCategorys
    }
  },
  created () {
    this.getDataList(1)
    this.getDepartments()
    this.getTypes()
  },
  methods: {
    async getDepartments () {
      const list =
        this.$store.state.data.ALL_DEPARTMENTS.length > 0
          ? this.$store.state.data.ALL_DEPARTMENTS
          : await this.$store.dispatch('GetAllDepartment').then()

      const vlist = []
      list.map((e) => {
        vlist.push({
          label: e.name,
          value: e.id
        })
      })

      this.departments = vlist
    },

    async getTypes () {
      const list =
        this.$store.state.data.ALL_GOODSCATEGORYS.length > 0
          ? this.$store.state.data.ALL_GOODSCATEGORYS
          : await this.$store.dispatch('GetAllGoodsCategorys')

      const vlist = []
      list.map((e) => {
        vlist.push({
          label: e.title,
          value: e.id
        })
      })

      this.goodsCategorys = vlist
    },

    getDataList (page) {
      this.loading = true
      this.page.page = page
      const q = { ...this.queryParams }
      q.Offset = (page - 1) * q.Limit
      q.IsDelete = false

      if (this.$store.state.user.userInfo.departmentId) {
        q.DepartmentId = this.$store.state.user.userInfo.departmentId
      }

      api.gets(q).then((resp) => {
        this.list = resp.data
        this.page.total = resp.total
        this.loading = false
        this.getTableHeight()
      })
    },
    resetFun () {
      this.queryParams = {
        Limit: 20
      }

      this.getDataList(1)
    },
    delFormFun (record) {
      const _this = this
      _this.$confirm({
        title: '确定删除?',
        icon: createVNode(ExclamationCircleOutlined),
        content: createVNode(
          'div',
          {
            style: 'color:red;'
          },
          `即将删除数据：${record.title}`
        ),

        onOk () {
          api.del(record.id).then(() => {
            _this.$message.success('删除成功！')
            _this.getDataList(1)
          })
        }
      })
    },

    changeIsSelling (id, e) {
      this.loading = true
      api.selling(id, e).then(() => {
        this.$message.success('设置成功！')
        this.getDataList(this.page.page)
      })
    },

    getTableHeight () {
      const paddingBottom = this.page.total > this.queryParams.Limit ? 50 : 9
      const mainPadding = 30
      const thead = 56
      this.height =
        this.$refs.content.offsetHeight -
        this.$refs.search.offsetHeight -
        thead -
        paddingBottom -
        mainPadding

      this.width = this.$refs.search.offsetWidth - 10
    },

    okForm (e) {
      this.getDataList(1)
    }
  }
})
</script>

<style lang="less" scoped>
.goods {
  display: flex;
  .pic {
    width: 60px;
    height: 60px;
    overflow: hidden;
    border-radius: 10px;
    img {
      display: block;
      width: 100%;
    }
  }
  .info {
    padding-left: 10px;
    .title {
      font-size: 18px;
      line-height: 36px;
    }
  }
}
</style>
